import RecoverableException from '@/exceptions/RecoverableException'

class InvalidStoreException extends RecoverableException {
  public message = 'Invalid store state'
  public name = 'InvalidStoreStateError'
}

export default InvalidStoreException
